import { getUrl, Routes } from 'lightning-common/lib/routing';
import { getSupportUrl } from 'lightning-common/lib/support-url';

import { useUserInfo } from '../../hooks/use-user-info';
import { getHtmlCopy, getTextCopy } from '../../i18n';
import { Modal } from '../modal/Modal';
import { Message } from '../../components/utils/Message';

export interface SupportChoiceModalProps {
    isConsortium?: boolean;
    libraryKey?: string;
    librarySupportEmail?: string;
    librarySupportUrl?: string;
    onClose?: () => void;
    open?: boolean;
}

export const SupportChoiceModal = ({
    isConsortium,
    libraryKey,
    librarySupportEmail,
    librarySupportUrl,
    onClose,
    open,
}: SupportChoiceModalProps) => {
    const { locale } = useUserInfo();
    return (
        <Modal
            aria-labelledby="unstyled-modal-title"
            aria-describedby="unstyled-modal-description"
            classes="support-choice-modal"
            heading={getHtmlCopy('supportChoiceModal.title')}
            id="cancel-hold-modal"
            onClose={onClose}
            open={open ?? false}
        >
            <div data-equalizer="support_text" data-equalizer-mq="large-12">
                <div className="row">
                    <div className="large-6 small-12 columns text-center support-choice-separator">
                        <div className="row">
                            <div
                                className="small-12 columns"
                                data-equalizer-watch="support_text"
                            >
                                <Message
                                    className="bold support-choice-label"
                                    elementType="p"
                                    messageKey="supportChoiceModal.lookingForHelp"
                                />
                            </div>

                            <div className="small-12 columns">
                                <a
                                    href={getSupportUrl(locale, undefined, {
                                        libraryKey,
                                        librarySupportUrl,
                                        isEdge: true,
                                    })}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="button margin-small radius primary support-choice-button u-allCaps"
                                >
                                    <Message messageKey="supportChoiceModal.visitHelpSite" />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="large-6 small-12 columns">
                        <div className="row">
                            <div
                                className="small-12 columns text-center"
                                data-equalizer-watch="support_text"
                            >
                                <p className="bold support-choice-label">
                                    {getTextCopy(
                                        'supportChoiceModal.cantFindAnswer'
                                    )}
                                </p>
                            </div>
                        </div>

                        <div className="small-12 columns text-center">
                            {!isConsortium &&
                            (librarySupportUrl || librarySupportEmail) ? (
                                <>
                                    {librarySupportUrl ? (
                                        <>
                                            <a
                                                className="button margin-small radius secondary support-choice-button u-allCaps js-last-focus"
                                                tabIndex={0}
                                                href={librarySupportUrl}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                {getHtmlCopy('contactSupport')}
                                            </a>
                                        </>
                                    ) : (
                                        <>
                                            <a
                                                className="button margin-small radius secondary support-choice-button u-allCaps js-last-focus"
                                                tabIndex={0}
                                                href={`mailto:${librarySupportEmail}`}
                                            >
                                                {getHtmlCopy('contactSupport')}
                                            </a>
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    <a
                                        className="button margin-small radius secondary support-choice-button u-allCaps js-last-focus"
                                        tabIndex={0}
                                        href={getUrl(Routes.supportMembers)}
                                    >
                                        {getHtmlCopy('contactSupport')}
                                    </a>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
